import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {string?} State */
const initialState = 'modifiedOn,desc';

const updateState = (state, { payload }) => payload.request.params?.sort ?? state;

export default createReducer(initialState, {
  [types.FETCH_ALL_BY_DEALER]: updateState,
});
